
export type GetTweetFeed200TweetsItemContent = {
  mentions?: string[];
  /**
   * @maxLength 280
   * @nullable
   */
  text?: string | null;
};
